import request from '@/common/request'
/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
  getCronCn: params => {
    return request({
      url: '/job/getCronCn',
      method: 'post',
      params
    })
  },
  createJob: (dynaSeg, data, params) => {
    return request({
      url: '/job',
      method: 'post',
      data,
      params
    })
  },
  deleteJob: (dynaSeg, data, params) => {
    return request({
      url: `/job/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  updateJob: (dynaSeg, data, params) => {
    return request({
      url: `/job/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryJob: params => {
    return request({
      url: '/job',
      method: 'get',
      params
    })
  },
  getJobTypeList:()=>{
    return request({
        url: '/job/jobType',
        method: 'get'
      })
  },
  initJob:() =>{
    return request({
        url: '/job/initJob',
        method: 'get'
      })
  },
  clearJob:() =>{
    return request({
        url: '/job/clearJob',
        method: 'get'
      })
  }
}


// WEBPACK FOOTER //
// ./src/api/modules/qrtz.js